import CommonSlice from "./CommonSlice";
import ContactSlice from "./ContactSlice";

export const reducers = {
    common: CommonSlice,
    contact: ContactSlice,
};